import $ from 'jquery';
import _ from "lodash";

import React from "react";
import { getCallReportsQuery, getCallReport } from "../graph";
import { withApollo } from "react-apollo";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import ReportIcon from "@material-ui/icons/Report";
import IconCard from "components/Cards/IconCard";
import Pageview from "@material-ui/icons/Pageview";
import Tooltip from 'material-ui/Tooltip';
import withStyles from "material-ui/styles/withStyles";

import Table from '../../elements/Table';
import Loading from "../../etc/Loading";
import Utils from "lib/utils";
import DetailedReportView from "./DetailedReportView";


class CallReportsView extends React.Component {

    constructor(props) {
      super(props);

      this.state = { 
        reports: [],
        loading: true, 
        pages: 0,
        reportModalIsOpen: false
      };

      this.data = {};

      this.headers = [
            {Header:"Server ID",accessor:"crId", minWidth: 50},
            {Header:"Reported By",accessor:"username", truekey: "user", sortable:false, 
                Cell: row => <div><span title={row.value}>{row.value}</span></div>},
            {Header:"Pin",accessor:"pin", truekey: "pin1", minWidth: 50},
            {Header:"Project ID",accessor:"pid", minWidth: 50},
            {Header:"Description",accessor:"description", sortable:false,
              filterable:false, Cell: row => <div><span title={row.value}>{row.value}</span></div>},
            {Header:"Reported On",accessor:"createdAt", sortable:true,
              filterable:false, Cell: row => <div><span title={row.value}>{row.value}</span></div>},
            {
              Header:"Actions",
              accessor:"actions",
              minWidth: 200,
              sortable:false,
              filterable:false
            }
      ];

      this.loadedAll = false;

      this.fetchData = this.fetchData.bind(this);
    }

    componentDidMount() {
      this.fetchData()
    }

    fetchData(state=null, instance=null, options={}) {
      this.setState({ loading: true })
      if (state){
          var filterBy = JSON.stringify(state.filtered)
          var offset = state.page
          var pageSize = state.pageSize
          var sort = JSON.stringify(state.sorted)
      } else {
          var filterBy = JSON.stringify([])
          var offset = 0
          var pageSize = 10
          var sort = JSON.stringify([])
      }
      if (offset == (this.state.pages-1)){
         options = {fetchPolicy: 'no-cache'}
      }

      this.props.client.query({
        query: getCallReportsQuery,
        variables: {
          filterBy: filterBy,
          offset: offset, 
          pageSize: pageSize,
          sort: sort
        }, 
        options: options
      }).then((data) => {
        this.setState({
          reports: data.data.callReports.callReports, 
          loading: false, 
          pages: data.data.callReports.pages
        });
      });
    }

    onViewReport(event) {
      this.props.client.query({
        query: getCallReport,
        variables: {
          crid: event.currentTarget.getAttribute("serverid")
        },
      }).then( (data) => {
        this.data = data.data.report;
        this.setState({
          reportModalIsOpen: true
        });
      });
    }

    onViewReportClose() {
      this.setState({
        reportModalIsOpen: false
      });
    }

    render() {
      const {classes} = this.props;
      const { reportModalIsOpen } = this.state;
      let reportModal = null;

      if (reportModalIsOpen) {
        reportModal = (<DetailedReportView 
          onClose={this.onViewReportClose.bind(this)}
          reportModalIsOpen={reportModalIsOpen} 
          data={this.data} />);
      }

      let table_data = {
        id: "callReportsTable",
        rows : this.state.reports,
        header : this.headers,
        actions: ['view'],
        buttons: {
          'view': {
            'key': 'crId',
            'callback': this.onViewReport.bind(this),
            'style':{
              'obj':<Tooltip
                      id="tooltip-top"
                      title="View Call Report"
                      placement="top"
                      classes={{ tooltip: classes.tooltip }}
                    ><Pageview/></Tooltip>,
              'color':'warningNoBackground',
              'class':'',
            },
            'text':''
          }
        },
        hasSearchBar: false,   
      };
      let _this = this;
      return (
        <div>
        <GridContainer>
          <ItemGrid xs={12}>
            {reportModal}
            <IconCard
              icon={ReportIcon}
              title="Call Reports"
              content={
                <Table title="Call Reports" 
                data={table_data}
                pages={_this.state.pages}
                loading={_this.state.loading}
                onFetchData={_this.fetchData}
                defaultPageSize={10}
                 />
              }/>
            </ItemGrid>
        </GridContainer>
      </div>
      )
    }
}


export default withStyles()(withApollo(CallReportsView));



// WEBPACK FOOTER //
// ./src/views/reports/components/CallReportsView.js